import classNames from 'clsx'
import React from 'react'
import './AnimatedDots.scss'

type Props = {
  className?: string
}

const AnimatedDots: React.FC<Props> = props => {
  return (
    <div
      className={classNames('ods-dot', props.className)}
      data-qa-id={'animated-dots-root'}
    />
  )
}

export default AnimatedDots
